import { jsx } from "react/jsx-runtime";
import { ThemeProvider as SystemThemeProvider } from "@mui/system";
import { theme as defaultTheme, createTheme } from "../theme/index.js";
import { THEME_ID } from "../constants/index.js";
const ThemeProvider = ({
  children,
  theme: themeInput
}) => {
  let theme = defaultTheme;
  if (themeInput) {
    theme = createTheme(
      THEME_ID in themeInput ? themeInput[THEME_ID] : themeInput
    );
  }
  return /* @__PURE__ */ jsx(
    SystemThemeProvider,
    {
      theme,
      themeId: themeInput && THEME_ID in themeInput ? THEME_ID : void 0,
      children
    }
  );
};
export {
  ThemeProvider
};
